export type * from './types';
export {
  CONCURRENCIES, CONTRACTS, CONTRACT_TEMPLATES, DECISIONS, DECISION_TYPES, EVENTS, HANDOVER, KPI_SCORES, LEAVES, ORG, STAFF, TIME_ROWS, VACANT_SEATS,
} from './fixtures';
export * from './logic';

import {
  CONCURRENCIES, CONTRACTS, CONTRACT_TEMPLATES, DECISIONS, EVENTS, HANDOVER, KPI_SCORES, LEAVES, ORG, STAFF, TIME_ROWS, VACANT_SEATS,
} from './fixtures';

/** Nạp dữ liệu mẫu nhân sự: `fixtures` của zone gọi hàm này (B gắn vào `registerMeeFixtures`). */
export function registerHrFixtures(register: (entity: string, rows: readonly unknown[]) => void): void {
  register('hrStaff', STAFF);
  register('hrOrgBlock', ORG);
  register('hrConcurrency', CONCURRENCIES);
  register('hrVacantSeat', VACANT_SEATS);
  register('hrLeave', LEAVES);
  register('hrHandover', HANDOVER);
  register('hrTimeRow', TIME_ROWS);
  register('hrKpi', KPI_SCORES);
  register('hrEvent', EVENTS);
  register('hrContractTemplate', CONTRACT_TEMPLATES);
  register('hrContract', CONTRACTS);
  register('hrDecision', DECISIONS);
}
